import { Injectable } from "@angular/core";
import { Events, NavController } from "ionic-angular";
import { HttpClient } from "@angular/common/http";

import {
  LoginResponse,
  UserAccount,
  Client,
  DataSource,
  AppointmentQuery,
  Holiday,
  Absence,
  MedicoActual,
  AppointmentSchedule,
  FuenteAsociada,
  JSONResponse,
  cobertura,
  tipoAfiliadoCoberturas,
  errorLog,
  consultorio,
  DatosSesion,
  diagnostico,
  Medics,
  coberturaRecetario, coberturasRecetario, 
  itemsSetup, itemSetup,
} from "../../mediware-interfaces";
import {
  EVT_SESSION_CLIENT_CHANGED,
  MAX_ITEMS_ERRORLOG,
  FLAG_RECETA_ELECTRONICA,
  CLIENTS_PAGE,
} from "../../constants";
import { MediwareHubService } from "../mediware-hub/mediware-hub";

@Injectable()
export class SessionProvider {
  
  private session: LoginResponse = null;
  private clienteActual: string = "";
  private usuarioActual: string = "";
  private tipoUsuarioActual: string = "";
  private passActual: string = "";
  private sessionToken: string = "";
  private coberturas: cobertura[] = [];
  private tiposAfiliadoCoberturas: tipoAfiliadoCoberturas[] = [];
  private gerenciaCoberturas: string[] = [];
  private errorLog: errorLog[] = [];
  private consultorios: consultorio[] = [];
  private _mediwareHubService: MediwareHubService | null = null;

  constructor(
    // private mediwareHubService: MediwareHubService,
    private events: Events
  ) {}

  isActive(): boolean {
    return this.session != null;
  }

  setSession(session: LoginResponse): void {
    this.session = session;
    if (
      this.session.usuario.esMedico &&
      this.session.usuario.especialidad != "SECRETARIA" &&
      this.session.usuario.especialidad != "ADMINISTRATOR"
    ) {
      this.session.medicoActual = this.session.usuario;
    } else {
      //si no es medico (es una secretaria/administrativo)
      this.session.medicoActual = null;
      if (
        this.session.conexion && 
        this.session.conexion.data && 
        this.session.conexion.data.medicos && 
        this.session.conexion.data.medicos[0]
      ) {
        this.setPrimerMedico() //ponemos el primero
      }
    }
    this.events.publish(EVT_SESSION_CLIENT_CHANGED);
  }

  setUsuarioActual(usuario: string): void {
    this.usuarioActual = usuario;
  }
  setPassActual(pass: string): void {
    this.passActual = pass;
  }
  setTipoUsuarioActual(tipo: string): void {
    this.tipoUsuarioActual = tipo;
  }
  setClienteActual(cliente: string): void {
    this.clienteActual = cliente;
  }
  setTokenActual(
    usuario: string,
    pass: string,
    tipo: string,
    cliente: string,
    token: string
  ): void {
    this.usuarioActual = usuario;
    this.passActual = pass;
    this.tipoUsuarioActual = tipo;
    this.clienteActual = cliente;
    //this.sessionToken = token; //falta: pasar a token-based session
    this.sessionToken =
      "&tipoLogin=" +
      tipo +
      "&idUsuario=" +
      usuario +
      "&pass=" +
      pass +
      "&conectarA=" +
      cliente;
    //console.log(this.sessionToken);
  }
  getUsuarioActual(): string {
    return this.usuarioActual;
  }
  getPassActual(): string {
    return this.passActual;
  }
  getTipoUsuarioActual(): string {
    return this.tipoUsuarioActual;
  }
  getClienteActual(): string {
    return this.clienteActual;
  }
  getTokenActual(): string {
    return this.sessionToken; //falta: pasar a token-based session
  }

  removeSession(): void {
    this.session = null;
  }

  getUser(): UserAccount {
    return this.session.usuario;
  }
  setUser(nuevoUsuario: UserAccount): void {
    //2021-09-02 cargamos los datos del usuario actual, al cambiar de cliente no se recargaba y se estaba usando en algunas funciones y entonces devolvia datos desactualizados
    this.session.usuario = nuevoUsuario;
  }
  getUserName(): string {
    if (!this.session) return "";

    return this.session.usuario.nombreCompleto;
  }
  getUserCode(): number {
    return this.session.usuario.codigo;
  }
  getUserEnrollmentId(): number {
    //return this.session.usuario.matricula;
    let matriculaUsuario = this.session.usuario.matricula;
    //if (!matricula) {
    //matricula =  this.session.usuario.matricula; //por que carajo no toma los cambios
    //}
    return matriculaUsuario;
  }
  getUserEspecialidad(): string {
    if (!this.session) return "";

    return this.session.usuario.especialidad;
  }
  isUserSecretaria(): Boolean {
    if (!this.session) return false;

    return (
      this.session.usuario.especialidad == "SECRETARIA" ||
      this.session.usuario.especialidad == "ADMINISTRATOR"
    );
  }
  permiteSeleccionarMedico(): Boolean {
      return (this.isUserSecretaria() || (this.session.usuario.permisos.indexOf('ADMINISTRATOR') != -1)  );
  }
 getMedicosHijos(): Medics[] {
  if (!this.session) return [];

  const medicos = this.session.conexion.data.medicos;
  if (!medicos) return [];

  const medicoActual = this.getMedicoActual();
  if (!medicoActual) return [];

  const matriculaActual = String(medicoActual["MATRICULA"] || medicoActual.matricula);

  const hijos = medicos.filter(
    (m) => m["matriculaPadre"] != null &&
           m["matriculaPadre"] !== "" &&
           m["matriculaPadre"].trim() === matriculaActual.trim()
  );

  // buscamos al médico actual directamente en la lista, ya tiene la estructura correcta
  const medicoActualEnLista = medicos.find(
    (m) => m["MATRICULA"].trim() === matriculaActual.trim()
  );

  if (medicoActualEnLista) {
    hijos.push(medicoActualEnLista);
  }

  return hijos;
}

getMedicoParaMostrar(): any {
  const medicoActual = this.getMedicoActual();
  if (!medicoActual) return null;

  const matriculaPadre = medicoActual["matriculaPadre"];

  if (matriculaPadre && matriculaPadre !== "") {
    const medicos = this.session.conexion.data.medicos;
    const padre = medicos.find(
      (m) => m["MATRICULA"].trim() === matriculaPadre.trim()
    );
    if (padre) return padre;
  }

  return medicoActual;
}

tieneMedicoHijo(): boolean {
  return this.getMedicosHijos().length > 0;
}





 setMedicoActualByMatricula(matricula: number) {
  // 1. Validación de seguridad: Si no hay matrícula, no hacemos nada
  if (!matricula) {
    console.error('setMedicoActualByMatricula: La matrícula es undefined o null');
    return;
  }

  // 2. Buscar entre los medicos
  let itemMedico = this.session.conexion.data.medicos.find(
    (element) => element["MATRICULA"] == Number(matricula) 
  ); 
  
  // Nota: Usar Number(matricula) es más limpio que parseInt(matricula.toString())
  // y evita el error si matricula ya fuera un número.

  if (itemMedico) {
    this.session.medicoActual = itemMedico;
    return this.session.medicoActual;
  } else {
    console.warn(`No se encontró médico con matrícula: ${matricula}`);
    return;
  }
}

  getMedicoActual(): MedicoActual {
    //return this.session.medicoActual;
    if (!this.session) return null;
    if (!this.session.conexion) return null;
    if (!this.session.conexion.data) return null;
    if (!this.session.conexion.data.medicos) return null;
    
    if (!this.session.medicoActual) {
      this.session.medicoActual = this.session.conexion.data.medicos[0]; //ponemos el primero
    }
    return this.session.medicoActual;
  }
  getConsultorioPisoMedicoActual(): string {
    const medico = this.getMedicoActual();
    if (!medico) return '';
    const matricula = String(medico['MATRICULA'] || medico.matricula || '').trim();
    const entrada = this.session.conexion.data.medicos.find(
      (m) => String(m['MATRICULA']).trim() === matricula,
    );
    return entrada && entrada['consultorioPiso'] ? entrada['consultorioPiso'] : '';
  }
  getMedicoActualCode(): number {
    //if (this.session.medicoActual) {
    //  return this.session.medicoActual.codigo;
    //}
    //return -1; //si no esta seteado
    if (!this.session) return -1; //no hay session
    if (!this.session.medicoActual) {
      this.session.medicoActual = this.session.conexion.data.medicos[0]; //ponemos el primero
    }
    return this.session.medicoActual.codigo;
  }
  getMedicoActualName(): string {
    if (!this.session) return "";
    if (!this.session.medicoActual) {
      this.session.medicoActual = this.session.conexion.data.medicos[0]; //ponemos el primero
    }
    let nombre =
      this.session.medicoActual.nombreCompleto ||
      this.session.medicoActual["nombre"]; //falta: ver por que nombreCompleto y nombre, es algo en la definicion de las clases
    return nombre;
  }
  setMedicoActualMatricula(matricula: number) {
    this.session.medicoActual.matricula = matricula;
  }
  setMedicoActualNombre(nombre: string) {
    this.session.medicoActual.nombreCompleto = nombre;
  }
  getMedicoActualMatricula(): number {
    //let matriculaActual = this.session.medicoActual['MATRICULA']; //  uso element['MATRICULA'] porque la interfaz esta en minuscula y lo que devuelve el json en mayuscula y no coinciden sino. y si pongo .MATRICULA el compilador da error
    //if (!matriculaActual) {
    //  matriculaActual = this.session.usuario.matricula;
    //}
    //return matriculaActual;
    if (!this.session) return -1; //no hay session
    if (!this.session.medicoActual) {
      this.session.medicoActual = this.session.conexion.data.medicos[0]; //ponemos el primero
    }
    let matriculaActual = this.session.medicoActual["MATRICULA"]; //  uso element['MATRICULA'] porque la interfaz esta en minuscula y lo que devuelve el json en mayuscula y no coinciden sino. y si pongo .MATRICULA el compilador da error
    if (!matriculaActual) {
      matriculaActual = this.session.usuario.matricula;
    }
    return matriculaActual;
  }

  getDataSourceList(): DataSource[] {
    return this.session.usuario.fuenteDatos;
  }

  getDefaultAppointments(): AppointmentQuery {
    let turnosIniciales: AppointmentQuery;
    turnosIniciales = this.getActiveClient().turnos;
    //console.log(turnosIniciales);

    return turnosIniciales;
  }

  getDaysArray(): AppointmentSchedule[] {
  if (this.session) {
    let matriculaActual = this.getMedicoActualMatricula();
    if (matriculaActual && matriculaActual != -1) {
      if (this.session.conexion.data["horariosTodos"]) {
        // intentamos directo, y si no, con el .0
        const horarios = this.session.conexion.data.horariosTodos[matriculaActual]
          || this.session.conexion.data.horariosTodos[matriculaActual + ".0"];
        return horarios || null;
      }

      if (
        this.session.conexion &&
        this.session.conexion.data &&
        this.session.conexion.data.horarios &&
        this.session.conexion.data.horarios.horarios
      ) {
        return this.session.conexion.data.horarios.horarios.filter(
          (item) => item["MATRICULA"] === matriculaActual
        );
      }
    }
  }
  return null;
}

  // setActiveClient(client: Client): void {
  //   if (this.session) {
  //     this.session.conexion.data = client;

  //     this.setMedicoActualByMatricula(this.getMedicoActualMatricula());
  //     this.events.publish(EVT_SESSION_CLIENT_CHANGED);
  //   }
  // }

  setActiveClient(client: Client): void {
    if (this.session) {
      if (typeof this.session.conexion !== 'object' || !this.session.conexion) {
        this.session.conexion = {
          data: null, 
        };
      }
      this.session.medicoActual = null;

      this.session.conexion.data = client;

      this.setPrimerMedico();

      this.setMedicoActualByMatricula(this.session.usuario.matricula);
      this.events.publish(EVT_SESSION_CLIENT_CHANGED);
    }
  }

  setPrimerMedico(){
    if(this.session.conexion.data){
    this.session.medicoActual = this.session.conexion.data.medicos[0];
    }else{
      console.log("no hay medicos", this.session.conexion)
    }
    
  }
  

  // getActiveClient(): Client {
  //   if (this.session) {
  //     return this.session.conexion.data;
  //   }
  //   return null;
  // }

  // getActiveClientName(): string {
  //   if (!this.session) return "";

  //   return this.decodeHtml(this.getActiveClient().empresa);
  // }

  getActiveClient(): Client {
  if (this.session && this.session.conexion) {
    return this.session.conexion.data;
  }
}

getActiveClientName(): string {
  const client = this.getActiveClient();
  return client && client.empresa ? this.decodeHtml(client.empresa) : "";
}

  // getAdsURL(): string {
  //   if (!this.session) return "";

  //   if (window.innerWidth >= 800 && this.session.publicidad["large"]) {
  //     return this.session.publicidad["large"]["logo"];
  //   }

  //   return this.session.publicidad.logo;
  // }

  
  getAdsURL(): string {
    if (!this.session || !this.session.publicidad) return "";
  
    if (window.innerWidth >= 800 && this.session.publicidad["large"]) {
      return this.session.publicidad["large"]["logo"] || "";  // Devuelve un valor vacío si 'logo' es nulo
    }
  
    return this.session.publicidad.logo || "";  // Devuelve un valor vacío si 'logo' es nulo
  }

  getAdsLink() {
    if (!this.session) {
      return "";
    }
    return this.session.publicidad.link;
  }

  setAds(arrPublicidad): void {
    //2022-05-10 publicidades por cliente: de momento es un unico item pero en el futuro seran varios por cliente
    //  cada item de publicidad tiene un logo y un link
    this.session.publicidad = arrPublicidad;
  }

  getHolidaysDays(): Holiday[] {
    if (
      this.session &&
      this.session.conexion &&
      this.session.conexion.data &&
      this.session.conexion.data.feriados
    ) {
      return this.session.conexion.data.feriados;
    }
    return []; 
  }

  getAbsenceDays(): Absence[] {
  if (this.session) {
    if (this.getActiveClient().ausencias) {
      return this.getActiveClient().ausencias;
    } else {
      if (
        this.getMedicoActual() &&
        this.session.conexion.data.ausenciasTodos
      ) {
        const matriculaActual = this.getMedicoActualMatricula();
        return this.session.conexion.data.ausenciasTodos[matriculaActual]
          || this.session.conexion.data.ausenciasTodos[matriculaActual + ".0"]
          || null;
      }
    }
  }
  return null;
}

  decodeHtml(htmlString: string): string {
    var txt = document.createElement("textarea");
    txt.innerHTML = htmlString;
    return txt.value;
  }

  getFuentesAsociadas(): FuenteAsociada[] {
    if (
      this.session &&
      this.session.conexion &&
      this.session.conexion.data &&
      this.session.conexion.data.fuentesAsociadas
    ) {
      return this.session.conexion.data.fuentesAsociadas;
    }
    return []; // Devuelve un array vacío en lugar de `null`
  }

  tieneModuloPracticas(nombreModulo: string): boolean {
    //2021-04-09 ahora los modulos vienen desde la conexion/cliente activa (this.session.conexion.data)
    //if (!(this.session.usuario['modulos'])) {

    if (
      !this.session ||
      !this.session.conexion ||
      !this.session.conexion.data ||
      !this.session.conexion.data["modulos"]
    ) {
      return false; //no tiene modulos cargados
    }
    //return (this.session.usuario['modulos'].indexOf(nombreModulo) != -1);
    return this.session.conexion.data["modulos"].indexOf(nombreModulo) != -1;
  }
  /**
    en una estructura diccionario, devuelve el modulo correspondiente al codigoPractica enviado
        ['modulosXcodigo'] = ['42.01.01']
                                           ['nombreModulo'] = 'MedicalHistoryAddEntryPage'
                                           ['titulo']       = 'Consulta' (tentativo)
                             ['34.10.69']
                                           ['nombreModulo'] = 'PracticaDensitometriaPage'
                                           ['titulo']       = 'Densitometria' (tentativo)
    para navegar directamente, segun los modulos que tenga configurado el usuario/cliente
            el modulo generico es Consulta, o sea que si queres abrir alguna practica que no tengas, simplemente se abre en el consulta
            si se pasa codigoPractica = '' se abre Consulta     
  **/
  moduloSegunCodigo(codigoPractica: string): string {
    //2021-04-09 ahora los modulos vienen desde la conexion/cliente activa (this.session.conexion.data)
    let salida: string = "MedicalHistoryAddEntryPage"; //modulo generico

    if (codigoPractica) {
      if (
        this.session.conexion.data["modulosXcodigo"] &&
        this.session.conexion.data["modulosXcodigo"][codigoPractica]
      ) {
        salida =
          this.session.conexion.data["modulosXcodigo"][codigoPractica][
            "nombreModulo"
          ];
      }
    }
    return salida;
  }

  agregarCobertura(cobertura: cobertura) {
    this.coberturas.push(cobertura);
  }

 

  setCoberturas(array: Array<cobertura>): void {
    this.coberturas = array;
  }
  getCoberturas(): cobertura[] {
    if (this.session) {
      return this.coberturas;
    }
    return null;
  }
  setTiposAfiliadoCoberturas(array: Array<tipoAfiliadoCoberturas>): void {
    this.tiposAfiliadoCoberturas = array;
  }
  getTiposAfiliadoCoberturas(): tipoAfiliadoCoberturas[] {
    if (this.session) {
      return this.tiposAfiliadoCoberturas;
    }
    return null;
  }
  setGerenciaCoberturas(arrGerencias: Array<string>): void {
    this.gerenciaCoberturas = arrGerencias;
  }
  getGerenciaCoberturas(): string[] {
    if (this.session) {
      return this.gerenciaCoberturas;
    }
    return null;
  }

  setConsultorios(array: Array<consultorio>): void {
    this.consultorios = array;
  }

  getConsultorios(): consultorio[] {
    if (this.session) {
      return this.consultorios;
    }
    return null;
  }

  setDiagnosticos(diagnosticos: diagnostico[]): any {
    if (diagnosticos) {
      this.session.conexion.data["diagnosticos"] = diagnosticos;
       this.session.conexion.data["diagnosticos"];
    } else {
      console.log("No hay diagnósticos");
    }
  }

  getDiagnosticos(): diagnostico[] {
    if (!this.session || !this.session.conexion || !this.session.conexion.data) {
      console.log("No se han encontrado datos en la sesión");
      return null;
    }
  
    // Verificar si 'diagnosticos' existe en 'data'
    const diagnosticos = this.session.conexion.data["diagnosticos"];
    
    if (!diagnosticos) {
      console.log("No se encontraron diagnósticos en los datos de sesión.");
      return null;
    }
      
    return diagnosticos;
  }

  agregarDiagnostico(diagnostico:diagnostico){
    this.session.conexion.data["diagnosticos"].push(diagnostico)
  }

  setCoberturasRecetario(coberturasRecetario: coberturaRecetario[]): any {
    if (coberturasRecetario) {
      this.session.conexion.data['recetario'] = [];
      this.session.conexion.data['recetario']["coberturas"] = coberturasRecetario['coberturasRecetario'];
      this.session.conexion.data['recetario']["sinonimos"] = coberturasRecetario['sinonimos'];
    } else {
      console.log("No hay coberturas recetario");
    }
  }
  getCoberturasRecetario(): coberturaRecetario[] {
    // Verificar si 'coberturasRecetario' existe en 'data'
    if (!this.session || !this.session.conexion || !this.session.conexion.data) {
      console.log("No se han encontrado datos en la sesión");
      return null;
    }
    const coberturasRecetario = this.session.conexion.data["recetario"];
    if (!coberturasRecetario) {
      console.log("No se encontraron coberturasRecetario en los datos de sesión.");
      return null;
    }
      
    return coberturasRecetario;
  }

  agregarLog(data: errorLog): void {
    if (localStorage.getItem("errorLog")) {
      this.errorLog = JSON.parse(localStorage.getItem("errorLog"));
    }
    this.errorLog.push(data);
    if (this.errorLog.length > MAX_ITEMS_ERRORLOG) {
      this.errorLog.slice(1);
    }
    localStorage.setItem("errorLog", JSON.stringify(this.errorLog));
  }

  getLog(): errorLog[] {
    if (localStorage.getItem("errorLog")) {
      this.errorLog = JSON.parse(localStorage.getItem("errorLog"));
    }
    return this.errorLog;
  }

  vaciarLog(): void {
    this.errorLog = [];
    localStorage.removeItem("errorLog");
  }

  getPatientAge(dateString: string): string {
    //2021-03-31 fechanac ahora viene yyyy-mm-dd
    //    https://www.geeksforgeeks.org/how-to-check-a-date-is-valid-or-not-using-javascript/#:~:text=Approach%202
    //// dd-mm-yyyy -> yyyy-mm-dd, ISO 8601
    //dateString = dateString.substr(6, 4) + "-" + dateString.substr(3, 2) +"-" + dateString.substr(0, 2);
    let birthDate = new Date(dateString);
    let today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age.toString();
  }

  getRecetarioComArBearerAuth(): string {
    return this.session['recetarioBearerAuth'] || this.session.conexion.data[FLAG_RECETA_ELECTRONICA]['token'] || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MjN9.k1Vu8-hNp7uDXA9w5uT3pgpVDymlk6Y0_maUDslN2kk' || ''; //despues vaciarlo cuando vaya a produccion
  }
  getRecetarioItems(): any {
    let matriculaMedicoActual = (Number(this.session.medicoActual.matricula) || Number(this.session.medicoActual['MATRICULA']));
    let itemsRecetario = this.session.conexion.data[FLAG_RECETA_ELECTRONICA];
    let itemRecetarioEnBlanco = [];
    itemRecetarioEnBlanco['idInstitucion'] = itemsRecetario['idInstitucion'];
    itemRecetarioEnBlanco['token'] = itemsRecetario['token'];
    itemRecetarioEnBlanco['doctor'] = [];
    itemRecetarioEnBlanco['doctor']['profile'] = [];
//console.log(matriculaMedicoActual,itemsRecetario['doctor']['licenseNumber'],Number(itemsRecetario['doctor']['licenseNumber']) == matriculaMedicoActual);    
    if (itemsRecetario && itemsRecetario['doctor'] && itemsRecetario['doctor']['licenseNumber'] && Number(itemsRecetario['doctor']['licenseNumber']) == matriculaMedicoActual ) {
        return this.session.conexion.data[FLAG_RECETA_ELECTRONICA];
    }
    
    return itemRecetarioEnBlanco;
  }
  
  setItemsSetup(items: itemsSetup) {
    if (!this.session || !this.session.conexion || !this.session.conexion.data) {
      console.log("No se han encontrado datos en la sesión");
      return null;
    }
    this.session.conexion.data["setup"] = items;
  }
  getItemsSetup(): itemsSetup {
    if (!this.session || !this.session.conexion || !this.session.conexion.data) {
      console.log("No se han encontrado datos en la sesión");
      return null;
    }
    // Verificar si 'setup' existe en 'conexion.data'
    const setup = this.session.conexion.data["setup"];
    if (!setup) {
      console.log("No se encontro setup en la fuente de datos.");
      return null;
    }
      
    return setup;
  }
  getSetup(clave: string): itemSetup {
    if (!this.session || !this.session.conexion || !this.session.conexion.data) {
      console.log("No se han encontrado datos en la sesión");
      return null;
    }
    return this.session.conexion.data["setup"].filter( (item) => item.valor = clave );
  }
}



// WEBPACK FOOTER //
// ./src/providers/session/session.ts